/**
 * logging abstraction facade
*/
const Facade_Logger={
    /**
     * log to console
     * 
     * @param {any} data
    */
    log:function(data)
    {
        console.log(data);
    }
}

/*
 *==================================
 *EXPORTS
 *==================================
*/
export {Facade_Logger};